module.exports = __webpack_public_path__ + "img/3dmglow.e620e891.png";